// AccountSettings.js
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
} from "@chakra-ui/react";
import { fetchAllUserNotificationPreferences } from "../../api/accountSettings";

// ADMIN: Show all users' notification preferences
const AllUsersNotificationPreferences = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchAllUserNotificationPreferences();
        setUsers(res.data || res.result || []);
      } catch (err) {
        setError("Failed to load notification preferences.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading)
    return <Box p={8}>Loading all users' notification preferences...</Box>;
  if (error)
    return (
      <Box p={8} color="red.500">
        {error}
      </Box>
    );

  return (
    <Box>
      <Box
        flex="1"
        display="flex"
        flexDirection="column"
        maxH="8vh"
        borderBottom="1px"
        borderColor="blackAlpha.200"
        overflowY="hidden"
      >
        <Box
          display="flex"
          alignItems="center"
          width="100%"
          height="100%"
          p={4}
          pt={2}
          pb={2}
          boxSizing="border-box"
          overflowY="hidden"
        >
          <Text
            fontSize="md"
            fontWeight="bold"
            mb={0}
            mt={0}
            color="blackAlpha.700"
          >
            Notification Preferences
          </Text>
        </Box>
      </Box>

      <Box p={8}>
        {users.length === 0 ? (
          <Text>No users found.</Text>
        ) : (
          <TableContainer>
            <Table variant="simple" size="sm">
              <Thead>
                <Tr>
                  <Th>Email</Th>
                  <Th>Account Notifications</Th>
                  <Th>Form Submissions</Th>
                  <Th>Newsletter</Th>
                  <Th>Last Updated</Th>
                  <Th>Created</Th>
                </Tr>
              </Thead>
              <Tbody>
                {users.map((user, idx) => (
                  <Tr key={user.email || idx}>
                    <Td fontWeight="medium">
                      {user.email || `User #${idx + 1}`}
                    </Td>
                    <Td>
                      <Badge
                        colorScheme={
                          user.user_account_notifications ? "green" : "red"
                        }
                        variant="subtle"
                      >
                        {user.user_account_notifications ? "On" : "Off"}
                      </Badge>
                    </Td>
                    <Td>
                      <Badge
                        colorScheme={
                          user.submitted_forms_notifications ? "green" : "red"
                        }
                        variant="subtle"
                      >
                        {user.submitted_forms_notifications ? "On" : "Off"}
                      </Badge>
                    </Td>
                    <Td>
                      <Badge
                        colorScheme={
                          user.newsletter_subscription ? "green" : "red"
                        }
                        variant="subtle"
                      >
                        {user.newsletter_subscription ? "On" : "Off"}
                      </Badge>
                    </Td>
                    <Td fontSize="xs" color="gray.600">
                      {user.updated_at
                        ? new Date(user.updated_at).toLocaleDateString()
                        : "N/A"}
                    </Td>
                    <Td fontSize="xs" color="gray.600">
                      {user.created_at
                        ? new Date(user.created_at).toLocaleDateString()
                        : "N/A"}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  );
};

export default AllUsersNotificationPreferences;
